import React from "react";
import clsx from "clsx";

const AppTag = ({
  children,
  variant = "success",
  size = "md",
  className = "",
  customClassName = "",
  ...restProps
}) => {
  const variants = {
    success: "bg-green-50 text-green-600",
    warning: "bg-yellow-50 text-yellow-600",
    error: "bg-red-50 text-red-600",
    info: "bg-blue-50 text-blue-600",
    neutral: "bg-gray-100 text-gray-600",
    processing: "bg-yellow-50 text-yellow-600",
    custom: customClassName,
  };

  const sizes = {
    sm: "px-3 py-1 text-xs",
    md: "px-5 py-2 text-sm",
    lg: "px-6 py-2.5 text-base",
  };

  return (
    <span
      className={clsx(
        "inline-flex items-center justify-center rounded-full font-medium",
        variants[variant],
        sizes[size],
        className
      )}
      {...restProps}
    >
      {children}
    </span>
  );
};

export default AppTag;
